/**
 * CAPTAIN TOM'S mobile header drawer swipe controls.
 * - Swipe right from the left edge to open.
 * - Swipe left while the drawer is open to close.
 *
 * Uses the current <header-drawer> custom-element API so it continues to work
 * when Shopify hydrates or replaces the header markup after initial load.
 */
(() => {
  const OPEN_EDGE_PX = 36;
  const MIN_HORIZONTAL_DISTANCE_PX = 60;
  const MAX_VERTICAL_DISTANCE_PX = 80;
  const MOBILE_MEDIA_QUERY = '(max-width: 989px)';

  let startX = 0;
  let startY = 0;
  let tracking = false;

  const isMobile = () => window.matchMedia(MOBILE_MEDIA_QUERY).matches;

  const getHeaderDrawer = () => document.querySelector('header-drawer');

  const drawerIsOpen = (drawer) => {
    if (!drawer) return false;
    if (typeof drawer.isOpen === 'boolean') return drawer.isOpen;
    return drawer.querySelector('details[open], details.menu-open') !== null;
  };

  const openDrawer = (drawer) => {
    if (!drawer || drawerIsOpen(drawer)) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    drawer.querySelector('.header__icon--menu, summary')?.click();
  };

  const closeDrawer = (drawer) => {
    if (!drawer || !drawerIsOpen(drawer)) return;

    if (typeof drawer.close === 'function') {
      drawer.close();
      return;
    }

    drawer.querySelector('.menu-drawer__close-button, .header__icon--menu, summary')?.click();
  };

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!isMobile() || event.touches.length !== 1) {
        tracking = false;
        return;
      }

      const touch = event.touches[0];
      const drawer = getHeaderDrawer();
      const isOpen = drawerIsOpen(drawer);

      // Opening gestures must begin at the left edge. Closing gestures may
      // begin anywhere inside the currently open drawer.
      if (!isOpen && touch.clientX > OPEN_EDGE_PX) {
        tracking = false;
        return;
      }

      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      if (!tracking || !isMobile() || event.changedTouches.length !== 1) return;
      tracking = false;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;

      // Ignore vertical scrolling and short/accidental gestures.
      if (
        Math.abs(deltaY) > MAX_VERTICAL_DISTANCE_PX ||
        Math.abs(deltaX) < MIN_HORIZONTAL_DISTANCE_PX ||
        Math.abs(deltaX) <= Math.abs(deltaY)
      ) {
        return;
      }

      const drawer = getHeaderDrawer();
      const isOpen = drawerIsOpen(drawer);

      if (!isOpen && startX <= OPEN_EDGE_PX && deltaX > 0) {
        openDrawer(drawer);
      } else if (isOpen && deltaX < 0) {
        closeDrawer(drawer);
      }
    },
    { passive: true }
  );

  document.addEventListener('touchcancel', () => {
    tracking = false;
  }, { passive: true });
})();
